var exports = {
  "k": "xcc377c0b--1b38e0--container",
};

module.exports = exports;
